import type { FC } from 'react'
import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'

// todo use render props to inject cards

const DraggableList: FC<any> = ({ list, updateList, DraggableChild }) => {
  const reorder = (items, startIndex, endIndex) => {
    const results = [...items]
    const [removed] = results.splice(startIndex, 1)
    results.splice(endIndex, 0, removed)
    return results
  }

  const getItemStyle = (isDragging, draggableStyle) => ({
    ...draggableStyle,
  })

  const getListStyle = () => ({})

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return
    }

    const newList = reorder(list, result.source.index, result.destination.index)

    updateList(newList)
  }

  const onDelete = (id: number | string) => {
    const newList = list.filter((x) => x?.id !== id)
    updateList(newList)
  }

  return (
    <div>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable">
          {(droppableProvided) => (
            <div
              ref={(ref) => droppableProvided.innerRef(ref)}
              style={getListStyle()}
            >
              {!!list &&
                !!list.length &&
                list.map((item, index) => (
                  <Draggable
                    key={item?.id}
                    draggableId={`item-${item?.id}`}
                    index={index}
                  >
                    {(draggableProvided, draggableSnapshot) => (
                      <div
                        ref={(ref) => draggableProvided.innerRef(ref)}
                        {...draggableProvided.draggableProps}
                        {...draggableProvided.dragHandleProps}
                        style={getItemStyle(
                          draggableSnapshot.isDragging,
                          draggableProvided.draggableProps.style,
                        )}
                      >
                        <DraggableChild {...item} onDelete={onDelete} />
                      </div>
                    )}
                  </Draggable>
                ))}
              {droppableProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  )
}

export default DraggableList
